import { AppHeader } from "@/components/layout/AppHeader";
import { AppFooter } from "@/components/layout/AppFooter";
import { cn } from "@/lib/utils";

export function PageShell({ children, className, hideFooter = false }) {
  return (
    <div className="min-h-screen bg-background">
      <AppHeader />
      <main className={cn("relative", className)}>{children}</main>
      {!hideFooter && <AppFooter />}
    </div>
  );
}
